// react
import { useState, useRef } from 'react';

// mui
import { Grid, Button, TextField } from '@mui/material';

// api
import { ProfileChangePassword } from '../../api';

// client-shared
import { valid } from '@goldblack/client-utils';

function SettingAccountChangePassword({ onCancel }) {
    const newPasswordRef = useRef();
    const confirmPasswordRef = useRef();
    const [newPasswordErrorText, setNewPasswordErrorText] = useState('');
    const [confirmPasswordErrorText, setConfirmPasswordErrorText] = useState('');
    const [disableChange, setDisableChange] = useState(true);

    const onChangePassword = () => {
        ProfileChangePassword(newPasswordRef.current.value);
    };

    const onChangeNewPassword = (event) => {
        let passwordCheck = valid.checkValidationPassword(newPasswordRef.current.value);
        let passwordNotEmpty = newPasswordRef.current.value !== '';
        if (!passwordCheck && passwordNotEmpty) {
            setNewPasswordErrorText(
                'Password must be at least 8 characters long and includes a number, an uppercase letter and a lowercase letter',
            );
        } else {
            setNewPasswordErrorText('');
        }
        checkDisableChange();
    };

    const onChangeConfirmPassword = (event) => {
        let passwordConfirmCheck = newPasswordRef.current.value !== confirmPasswordRef.current.value;
        let passwordConfirmNotEmpty = confirmPasswordRef.current.value !== '';
        if (passwordConfirmCheck && passwordConfirmNotEmpty) {
            setConfirmPasswordErrorText('password mismatch');
        } else {
            setConfirmPasswordErrorText('');
        }
        checkDisableChange();
    };

    const checkDisableChange = (event) => {
        let passwordCheck = valid.checkValidationPassword(newPasswordRef.current.value);
        let passwordConfirmCheck = newPasswordRef.current.value === confirmPasswordRef.current.value;
        setDisableChange(!(passwordCheck && passwordConfirmCheck));
    };

    const onChangePasswordCancel = () => {
        onCancel?.();
    };

    return (
        <Grid container spacing={1} direction='column' justifyContent='center' alignContent='center' sx={{ mt: 3 }}>
            <Grid sx={{ m: 1 }}>
                <TextField
                    required
                    fullWidth
                    autoFocus
                    inputRef={newPasswordRef}
                    label='New password'
                    type='password'
                    autoComplete='new-password'
                    onChange={onChangeNewPassword}
                    helperText={newPasswordErrorText}
                />
            </Grid>
            <Grid sx={{ m: 1 }}>
                <TextField
                    required
                    fullWidth
                    inputRef={confirmPasswordRef}
                    label='Confirm new password'
                    type='password'
                    autoComplete='new-password'
                    onChange={onChangeConfirmPassword}
                    helperText={confirmPasswordErrorText}
                />
            </Grid>
            <Grid sx={{ m: 1 }}>
                <Button variant='contained' fullWidth disabled={disableChange} onClick={onChangePassword}>
                    Change
                </Button>
            </Grid>
            <Grid sx={{ m: 1 }}>
                <Button variant='outlined' fullWidth onClick={onChangePasswordCancel}>
                    Cancel
                </Button>
            </Grid>
        </Grid>
    );
}

export { SettingAccountChangePassword };
